import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EditPage } from '../edit_page/EditPage';
import {
	budgetsRestCrudThunksForBuyer,
	budgetsRestCrudThunksForSupplier,
} from '../../thunks/budget_thunks';
import BudgetForm from '../budget_form/BudgetForm';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { withUserType } from '../withUserType';
import { ROLE_TYPES } from '../../utils/DataConstants';
class NewBudgetPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			backLinkParams: '',
		};
	}

	render() {
		const { history, fetching, userType } = this.props;

		//noinspection TypeScriptUnresolvedVariable
		return fetching ? (
			<PageLoadingPlaceholder />
		) : (
			[
				<EditPage
					title="Create Budget"
					formComponentProps={{
						formData: {},
						isEditForm: false,
						onSuccess: (rec) => history.push(`/${userType}/budgets/detail/${rec.id}/details`),
					}}
					fetching={fetching}
					FormComponent={BudgetForm}
				/>,
			]
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		budget: state.budgets.detail,
		fetching: state.budgets.fetching,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getBudget: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? budgetsRestCrudThunksForSupplier.readOne(id)
				: budgetsRestCrudThunksForBuyer.readOne(id)
		),
});

export default withUserType(
	withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(NewBudgetPage as any)) as any
);
